<template>
    <div class="RefundView">
    </div>
</template>

<script>
  export default {
    name: 'RefundView',
    data() {
      return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .RefundView {
    }
</style>
